// extracted by mini-css-extract-plugin
export default {"section":"viewtype_section__jbsGx","sectionHeading":"viewtype_sectionHeading__w2yHl","table":"viewtype_table__Zspzt"};